angular.module('picmonicng').factory('Users', [
  '$resource',
  function ($resource) {
    return $resource('/api/v2/users/:userId/:resource', {
      userId: '@id',
      resource: '@resource',
    });
  },
]);
